import firstUpperCase from "./firstUpperCase"
export default function getMargin(dom,dir=top){
	const style = getComputedStyle(dom);
	if(!style) return 0;
	dir = firstUpperCase(dir);
	const key = `margin${dir}`;
	const margin = style[key];
	if(!margin) return 0;
	return margin.replace("px","") * 1;
}